'use client'

import { useEffect, useState } from 'react'
import Script from 'next/script'
import GoogleMapsContext from 'context/common/GoogleMapsContext'

const withGoogleMapsScript = <P extends object>(
  WrappedComponent: React.FC<P>,
  libraries: string[]
): React.FC<P> => {
  const WrappedGoogleMapsComponent = (props) => {
    const libraryKeys = libraries.join(',')
    const [
      googleMapsScriptLoading,
      setGoogleMapsScriptLoading,
    ] = useState<boolean>(true)

    // Checks if the script has been loaded
    useEffect(() => {
      if (window.google) {
        setGoogleMapsScriptLoading(false)
      }
    }, [])

    return (
      <GoogleMapsContext.Provider
        value={{
          googleMapsScriptLoading,
          setGoogleMapsScriptLoading,
        }}
      >
        <Script
          defer
          onLoad={() => setGoogleMapsScriptLoading(false)}
          onError={() => setGoogleMapsScriptLoading(false)}
          src={`https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GMP_KEY}&libraries=${libraryKeys}&callback=Function.prototype`}
        />
        <WrappedComponent {...(props as P)} />
      </GoogleMapsContext.Provider>
    )
  }

  return WrappedGoogleMapsComponent
}

export default withGoogleMapsScript
